module.exports = "/lucky-balls/img/weager/Lower_Raise/Button_Higher_plus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Lower_Raise/Button_Higher_plus.png
// module id = 1163
// module chunks = 0